import { type SVGProps } from 'react';

import { withDynamicStroke } from '../../withDynamicStroke';
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.47 21.53a.75.75 0 1 0 1.06-1.06zm-3.72-11.28a6.5 6.5 0 0 1-6.5 6.5v1.5a8 8 0 0 0 8-8zm-6.5 6.5a6.5 6.5 0 0 1-6.5-6.5h-1.5a8 8 0 0 0 8 8zm-6.5-6.5a6.5 6.5 0 0 1 6.5-6.5v-1.5a8 8 0 0 0-8 8zm6.5-6.5a6.5 6.5 0 0 1 6.5 6.5h1.5a8 8 0 0 0-8-8zm4.72 12.28 5.5 5.5 1.06-1.06-5.5-5.5z"
    />
  </svg>
);
export const IconSearch = withDynamicStroke(Icon);
